module.exports = "/images/pin-multidis-active.png?2999eb7b382539385f45030ea740e00c";